module.exports = __webpack_public_path__ + "static/media/HS_identifyConvo.f874df8f.png";